import React from "react";
import './css/breadcrum.css'
import {
  Breadcrumbs,
  Typography,
  Skeleton,
  Box,
} from "@mui/material";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";

const BreadCrum = ({ product, loading }) => {
  if (loading) {
    return (
      <Box className="breadcrum-skeleton">
        <Skeleton width={100} height={24} />
      </Box>
    );
  }

  return (
    <Box className="breadcrum-container">
      <Breadcrumbs
        separator={<NavigateNextIcon fontSize="small" />}
        aria-label="breadcrumb"
      >
        <Typography color="text.primary" sx={{ fontWeight: 600 }}>
          Home
        </Typography>
        <Typography color="text.primary" sx={{ fontWeight: 600 }}>
          Shop
        </Typography>
        <Typography color="text.primary" sx={{ fontWeight: 600 }}>
          {product?.category || "Category"}
        </Typography>
        <Typography color="text.secondary" sx={{ fontWeight: 500 }}>
          {product?.name || "Product"}
        </Typography>
      </Breadcrumbs>
    </Box>
  );
};

export default BreadCrum;